import React, {} from 'react';


const ClusterItem = ({point, onClick}) => {
	
	return (
		<div onClick={()=>onClick(point.slices)}>({point.slices.join(",")}) {point.chance} {point.size}</div>
	);
};
export default ClusterItem;